import React, { FC } from 'react'
import styled from 'styled-components'
const isMobile = window.innerWidth < 712

const StyledLastCheck = styled.div`
  position: relative;
  width: 100%;
  text-align: center;
  display: inline-block;
  margin-top: 30px;
  margin-bottom: 60px;
  background: var(--orange-main);
  font-family: var(--font-plex);
  font-size: 15px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  line-height: 0;
`
const InfoText = styled.div`
  font-family: var(--font-plex);
  font-size: 15px;
  line-height: 22px;
  text-align: left;
  padding: 15px;

  /* background: white; */
  color: var(--brandblue-main);
  background: var(--brandblue-bright-5);

  @media only screen and (max-width: 711px) {
    line-height: 24px;
  }
  b {
    /* white-space: nowrap; */
  }
`

const Top = styled.div`
  width: 100%;
  border-bottom: 2px solid white;
  display: flex;
  align-items: center;
  line-height: 1.4em;
`
const Bottom = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`
const Label = styled.div`
  background: var(--orange-main);
  color: white;
  min-height: 65px;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  text-align: left;
  padding-left: 15px;
  letter-spacing: 0.4px;
  padding: 0.75em 0 0.75em 15px;
`

const Date = styled.div`
  flex: 0 0 auto;
  display: inline-block;
  max-width: 180px;
  background: var(--orange-main);
  color: white;
  font-size: 20px;
  font-weight: 700;
  padding: 1em 1em;
`
export const LastCheck: FC<{ date: string; labels: string[] }> = ({
  date,
  children,
  labels
}) => {
  return (
    <StyledLastCheck>
      <Top>
        <Label>{labels[0]}</Label>
        <Date>{date}</Date>
      </Top>
      <Bottom>
        <InfoText>{children}</InfoText>
      </Bottom>
    </StyledLastCheck>
  )
}
